import { environment } from '@environment/environment';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { EnvironmentType } from '@environment/environment-type';
import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

export const provideStoreDevToolsInLocal = (): EnvironmentProviders => {
  return environment.name === EnvironmentType.LOCAL
    ? provideStoreDevtools({
        maxAge: 25,
        logOnly: false,
      })
    : makeEnvironmentProviders([]);
};
